import { render, staticRenderFns } from "./WorkflowNexusConfiguration.vue?vue&type=template&id=42dd3d16"
import script from "./WorkflowNexusConfiguration.vue?vue&type=script&lang=js"
export * from "./WorkflowNexusConfiguration.vue?vue&type=script&lang=js"
import style0 from "./WorkflowNexusConfiguration.vue?vue&type=style&index=0&id=42dd3d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})
